import React from "react";
import {
  LearningPathArticlesIcon,
  LearningPathAssignmentIcon,
  LearningPathBadgeIcon,
  LearningPathCertificateCompletionIcon,
  LearningPathCourseIcon,
  LearningPathVideoIcon,
} from "../svgcomponents/lp-common-icons";

const CommonCourseDetailSection = ({ pageData, type }) => {
  const hasChapters =
    Array.isArray(pageData?.chapters) && pageData.chapters.length > 0;
  const lessons = hasChapters ? pageData.chapters[0]?.lessons?.lessons : [];

  const totalRead =
    lessons?.filter((data) => data?.text_lesson !== "").length || null;
  const totalVideo =
    lessons?.filter((data) => data?.video_lesson?.length !== 0).length || null;
  const totalQuiz = lessons?.filter((data) => data?.is_quiz).length || null;

  const skillTaxanomy = pageData?.taxonomies?.filter(
    (item) => item.taxonomy_uid === "skills"
  );

  return (
    <div className="d-flex flex-column justify-content-center align-items-start g-24 w-100">
      <div className="learning-path__included-section">
        <p className="learning-path__included-section-title">
          {type === "learning_pathway"
            ? "This learning path includes"
            : "This Course includes"}
        </p>

        {pageData && pageData?.chapters && pageData?.chapters[0] ? (
          <div className="learning-path__included-section-items">
            {!!totalRead && (
              <div className="learning-path__included-section-items-item">
                <LearningPathArticlesIcon />
                <span>
                  {totalRead}
                  {totalRead > 1 ? " Articles" : " Article"}
                </span>
              </div>
            )}
            {totalVideo && (
              <div className="learning-path__included-section-items-item">
                <LearningPathVideoIcon />
                <span>
                  {totalVideo}
                  {totalVideo > 1 ? " Videos" : " Video"}
                </span>
              </div>
            )}
            {totalQuiz && (
              <div className="learning-path__included-section-items-item">
                <LearningPathAssignmentIcon />
                <span>
                  {totalQuiz}
                  {totalQuiz > 1 ? " Quizzes" : " Quiz"}
                </span>
              </div>
            )}
          </div>
        ) : (
          <div className="learning-path__included-section-items">
            {pageData?.courses?.course.length > 0 && (
              <div className="learning-path__included-section-items-item">
                <LearningPathCourseIcon />
                <span>{pageData?.courses?.course?.length} Courses</span>
              </div>
            )}

            {/* Assignment section  */}
            {pageData?.assessment_test && (
              <div className="learning-path__included-section-items-item">
                <LearningPathAssignmentIcon />
                <span>1 Assignment</span>
              </div>
            )}

            {pageData?.learning_pathway_details?.awards_certifications ===
              "certificate" &&
              pageData?.is_assessment && (
                <div className="learning-path__included-section-items-item">
                  <LearningPathCertificateCompletionIcon />
                  <span>1 Certificate of Completion</span>
                </div>
              )}

            {/* Badge section  */}
            {pageData?.learning_pathway_details?.awards_certifications ===
              "badge" &&
              pageData?.is_assessment && (
                <div className="learning-path__included-section-items-item">
                  <LearningPathBadgeIcon />
                  <span>1 Badge</span>
                </div>
              )}
          </div>
        )}
      </div>
      {skillTaxanomy?.length > 0 && (
        <div>
          <h2 className="learning-path__skills-title">Skills Covered</h2>
          <div className="learning-path__skills-container">
            {skillTaxanomy?.map((skill, i) => (
              <p
                key={i}
                className="learning-path__skills-item"
                style={{ width: "max-content" }}
              >
                {skill?.term_uid.replace("_", " ")}
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CommonCourseDetailSection;
